import size from 'lodash/size';

export const projectNameIsInvalid = str =>
  !str.match(/^[a-zA-Z]+[a-zA-Z0-9_-]*$/);

export const stringIsInvalid = str => !str.match(/^[a-zA-Z]+[a-zA-Z0-9_]*$/);

export const copiedStringIsInvalid = str =>
  !str.match(/^[a-zA-Z]+[a-zA-Z0-9_-]*$/);

export const stringMaxLengthIsInvalid = str => size(str) > 96;
